// extracted by mini-css-extract-plugin
module.exports = {"tickerBarWrapper":"PhoenixTickerBarWrapper_tickerBarWrapper__2cAU2"};